<template>
    <div class="journey-board">
        <div class="back mb-3">
            <router-link
                :to="'/clients/journey'"
                class="btn btn-sm btn-secondary btn-goback"
            >
                {{ t('clients-journey-back') }}
            </router-link>
        </div>
        <h1>
            {{
                (parent && parent.name + " / " + stage.variant) ||
                t('clients-journey-title')
            }}
        </h1>
        <modal ref="moveOptions" id="moveOptions" :starts-open="false">
            <template slot="title">
                <div>
                    <h2>{{ currentlyMoving.sibling.name }}</h2>
                </div>
            </template>
            <template slot="body">
                <div>
                    <p>{{ t('clients-journey-move_to_which_board') }}</p>
                    <div v-if="moveOptions.length > 0">
                        <button
                            v-for="option in moveOptions"
                            :key="option.id"
                            @click="selectOption(option)"
                            class="btn btn-primary btn-option"
                        >
                            {{ option.variant }}
                        </button>
                    </div>
                </div>
            </template>
            <template slot="footer">
                <div>
                    <button class="btn btn-cancel" @click="cancelMovement">
                        {{ t('clients-modals-cancel') }}
                    </button>
                </div>
            </template>
        </modal>
        <modal ref="enterOptions" id="enterOptions" :starts-open="false">
            <template slot="title">
                <div>
                    <h2>{{ currentlyEntering.name }}</h2>
                </div>
            </template>
            <template slot="body">
                <div>
                    <div>
                        <router-link
                            v-for="(
                                node, variant
                            ) in currentlyEntering.variants"
                            :key="node.id"
                            class="btn btn-primary btn-option"
                            :to="'/clients/journey/board/' + node.id"
                        >
                            {{ variant }}
                        </router-link>
                    </div>
                </div>
            </template>
            <template slot="footer">
                <div>
                    <button class="btn btn-cancel" @click="cancelEnter">
                        {{ t('clients-modals-cancel') }}
                    </button>
                </div>
            </template>
        </modal>
        <div class="board">
            <div class="column" v-for="sibling in siblings" :key="sibling.id">
                <div>{{ sibling.name }}</div>
                <div v-if="sibling.children.length" class="cards">
                    <div class="counter">
                        {{ cards[sibling.id].length }} <br />
                        <button
                            class="btn btn-outline-success"
                            @click="enter(sibling)"
                        >
                            {{ t('clients-journey-enter') }}
                        </button>
                    </div>
                    <draggable
                        :list="cards[sibling.id]"
                        group="cards"
                        @change="move($event, sibling)"
                        class="dragArea"
                    >
                    </draggable>
                </div>
                <div v-else class="cards">
                    <draggable
                        :list="cards[sibling.id]"
                        group="cards"
                        @change="move($event, sibling)"
                        class="dragArea"
                    >
                        <div
                            v-for="card in cards[sibling.id]"
                            :key="card.id"
                            class="card"
                        >
                            <router-link :to="'/client/' + card.clients_id">
                                {{ card.whatsapp ? formatPhone(card.whatsapp) : "" }} <br />
                                {{ card.first_name }} {{ card.last_name }}
                            </router-link>
                        </div>
                    </draggable>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.clients-journey-board-stageId,
.clients-journey-board-stageId-childId {
    max-width: 100%;
}
</style>
<style scoped lang="scss">
.btn-option {
    display: block;
    width: 100%;
    margin: 10px 0;
}
.board {
    display: flex;
    height: calc(100vh - 200px);
    overflow-x: auto;
}
.column {
    flex: 1;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin: 5px;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: auto;
    min-width: 200px;
    .cards,
    .counter {
        flex-grow: 1;
    }
    .dragArea {
        min-height: 100%;
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
    .cards {
        display: flex;
        flex-direction: column;
        padding-top: 10px;
        gap: 10px;
        position: relative;
        .card {
            padding: 10px;
            font-size: 12px;
            cursor: pointer;
            background: #fff;
            a {
                color: #000;
            }
            &.sortable-ghost {
                opacity: 0.5;
            }
        }
    }
    .counter {
        position: absolute;
        top: 50%;
        right: 50%;
        font-size: 32px;
        font-weight: 600;
        color: #ccc;
        padding: 5px;
        border-radius: 5px;
        transform: translate(50%, -50%);
        text-align: center;
    }
}
</style>
<script>
import draggable from "vuedraggable";
import keviApi from "../../keviApi";
import phoneMixin from "../../mixins/phone-mixin";
export default {
    mixins: [phoneMixin],
    components: {
        draggable,
    },
    props: {
        type: String,
    },
    data: function () {
        return {
            parent: null,
            stage: null,
            siblings: [],
            cards: {},
            moveTitle: null,
            moveOptions: [],
            currentlyMoving: {
                client: {},
                sibling: {},
            },
            currentlyEntering: {},
        };
    },
    computed: {
        stageId: function () {
            return this.$route.params.stageId;
        },
        childId: function () {
            return this.$route.params.childId;
        },
        rootId: function () {
            return this.childId || this.stageId;
        },
    },
    async mounted() {
        this.loadBoard();
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        showCards(sibling) {
            if (sibling.children.length > 0) {
                return this.t('no');
            } else {
                return this.t('yes');
            }
        },
        async loadBoard() {
            let options = keviApi.getOptions(
                "client-stage/" + this.rootId + "/board",
                "GET",
            );
            const responseBoard = await this.$http(options);
            this.parent = responseBoard.data.parent;
            this.stage = responseBoard.data.stage;
            this.siblings = responseBoard.data.siblings;
            const cards = {};
            this.siblings.forEach((sibling) => {
                cards[sibling.id] = sibling.clients;
            });
            this.cards = cards;
        },
        move($event, sibling) {
            if ($event.added) {
                let options = keviApi.getOptions(
                    "client-stage/" + sibling.id + "/move",
                    "POST",
                    {
                        clients: [$event.added.element.clients_id],
                    },
                );
                this.$http(options).then(
                    (response) => {
                        this.moveOptions = [];
                        this.currentlyMoving = {
                            client: {},
                            sibling: {},
                        };
                        this.$refs.moveOptions.close();
                        this.$store.dispatch(
                            "notification/success",
                            this.t('clients-journey-move_success'),
                        );
                        $event.added.element.clients_stages_id =
                            response.body.clients_stages_id;
                    },
                    (error) => {
                        if (
                            error.body &&
                            error.body.error === "stage-has-children"
                        ) {
                            this.moveOptions = error.body.options;
                            this.currentlyMoving.client = $event.added.element;
                            this.currentlyMoving.sibling = sibling;
                            this.$refs.moveOptions.open();
                        }
                    },
                );
            }
        },
        cancelMovement() {
            this.moveOptions = [];
            this.cards[this.currentlyMoving.sibling.id] = this.cards[
                this.currentlyMoving.sibling.id
            ].filter((client) => {
                return (
                    client.clients_id !== this.currentlyMoving.client.clients_id
                );
            });
            if (this.cards[this.currentlyMoving.client.clients_stages_id]) {
                this.cards[this.currentlyMoving.client.clients_stages_id].push(
                    this.currentlyMoving.client,
                );
            }
            this.currentlyMoving = {
                client: {},
                sibling: {},
            };
            this.$refs.moveOptions.close();
        },
        selectOption(option) {
            this.move(
                {
                    added: {
                        element: this.currentlyMoving.client,
                    },
                },
                option,
            );
        },
        cancelEnter() {
            this.currentlyEntering = {};
            this.$refs.enterOptions.close();
        },
        enter(sibling) {
            this.currentlyEntering = sibling;
            this.$refs.enterOptions.open();
        },
    },
    watch: {
        rootId: function () {
            this.loadBoard();
            this.$refs.moveOptions.close();
            this.$refs.enterOptions.close();
        },
    },
};
</script>
<style lang="less" scoped></style>
